import { decryptId } from "../../../Components/CryptoComponent";
import AddLookup from "../../../Components/InputComponents/AddLookup";
import { useParams, useSearchParams } from "react-router-dom";

function EditDepartment() {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));

  const [searchParams] = useSearchParams();
  const redirectURL = `/DepartmentLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Edit Department"
      alert="Department Edited Successfully"
      editDataAPIEndPoint={`/Department/Edit/${decryptedId}`}
      viewDataDetailsAPIEndPoint={`/Department/listbyId/${decryptedId}`}
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Department",
              name: "DL_Name",
              required: true, // Validation rule added here
               maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "DL_Status",
              required: true, // Validation rule added here
                            options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        DL_Name: {
          required: true,
          
        },
        DL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default EditDepartment;
